<template>
  <div class="">
    <div class="card v-card-contact">
      <div class="card-body">
        <h2>CONTACT INFO</h2>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label for="">
                First Name (<small class="text-danger">*</small>)</label
              >
              <input
                type="text"
                v-model="$store.state.Contact.first_name"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="First Name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="">
                Last Name (<small class="text-danger">*</small>)</label
              >
              <input
                type="text"
                v-model="$store.state.Contact.last_name"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Last Name"
              />
              
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="">
                Email Address (<small class="text-danger">*</small>)</label
              >
              <input
                type="email"
                v-model="$store.state.Contact.email"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Email Address"
              />
              <div class="text-form">
                This is the email we will send your confirmation to.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            
            <div class="mb-3">
              <label for="">
                Phone number (<small class="text-secondary">Optional</small
                >)</label
              >
           
                <vue-tel-input placeholder="960986261" @country-changed="selectedcountry" v-model="$store.state.Contact.number"  ></vue-tel-input>
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label for=""> ADDITIONAL DETAILS AND PREFERENCES </label>
              <textarea
                name=""
                class="form-control"
                id=""
                v-model="$store.state.Contact.adicional"
                cols="10"
                rows="3"
                placeholder="Please note your requests or special needs"
              >
              </textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card v-card-contact mt-3">
      <div class="card-body">
        <h2>ACKNOWLEDGEMENT</h2>
        <div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="$store.state.Contact.term"
              value=""
              id="flexCheckDefault"
            />
            <label class="form-check-label" for="flexCheckDefault">
              (<span class="text-danger">*</span>) I agree with the Privacy
              Terms.
            </label>
            <a href="javascript:void(0)" @click="visible=true">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model:visible="visible" :footer="false" title="Termino Y Politica de reservas">
      <div>
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus
          praesentium accusamus soluta itaque reprehenderit. Delectus eaque,
          esse reprehenderit laborum quam illum nulla dignissimos officia dicta
          quas accusamus, temporibus, doloribus corrupti?
        </p>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { useStore } from "Vuex";
import { reactive,ref } from "Vue";
export default {
  props: {
    dataContact: Number,
  },
  setup(props, { emit }) {
    const store = useStore();
    const visible = ref(false);
    const Dataform = reactive({
      first_name: "Lucas",
      last_name: "",
      email: "",
      number: "",
      adicional: "",
      term: "",
    });
    const selectedcountry=(even)=>{
       store.state.Contact.country=even;
    }
    return {
      Dataform,
      selectedcountry,
      visible,
    };
  },
};
</script>